import Avatar from '../../../../customizations/volto/components/theme/Avatar/Avatar';
import { TCellComponent } from '../List';
import { flattenToAppURL, getColor } from '@plone/volto/helpers';

const CreatorCellContent: TCellComponent<string | undefined> = ({ data }) =>
  data != null ? (
    <Avatar
      src={flattenToAppURL('/@portrait/' + data)}
      title={data} /* TODO: Use fullname to create initials */
      color={getColor(data)}
      userId={data}
    />
  ) : null;

export default CreatorCellContent;
